export default __webpack_public_path__ + "static/media/logowhite.35a7e322.png";